<!--
@component
Spinning loader icon for any indeterminate in-progress state.

@use-instead-of Loader2/LoaderCircle with animate-spin, or a hand-rolled spinner
@see SkeletonPulse
-->
<script lang="ts">
  import Loader from "@lucide/svelte/icons/loader";
  import clsx from "clsx";

  let clazz: string | null = null;
  export { clazz as class };
</script>

<Loader class={clsx("animate-spin", clazz)} />
